export default "/images/bg-3.jpg?3154951d5a9908e1a132b0752f7606b0";